import React from 'react';
import PropTypes from 'prop-types';

import { ModalStyled, Inner, Button } from './styled';

function Modal({ children, onClose, open, className, size }) {
	return (
		<ModalStyled
			className={className}
			aria-labelledby="modal"
			size={size}
			open={open}
			onClose={onClose}>
			<Inner>
				<Button className="sds-btn-icon sds-btn-icon--flat" onClick={onClose}>
					<i className="material-icons">close</i>
				</Button>
				{children}
			</Inner>
		</ModalStyled>
	);
}

Modal.defaultProps = {
	size: 'md'
};

Modal.propTypes = {
	children: PropTypes.node.isRequired,
	onClose: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired,
	className: PropTypes.string,
	size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])
};

export default Modal;
